import request from '@/config/axios'

// 提成记录 VO
export interface CommissionRecordVO {
  id?: string | number
  shopId: string | number
  employeeId: string | number
  commissionType: string // SALES/CLEANING/MAINTENANCE
  sourceType: string // ORDER/CLEANING_TASK/MAINTENANCE_ORDER
  sourceId: string | number
  amount: number
  unitPrice?: number
  quantity?: number
  period?: string
  status: string // PENDING/APPROVED/PAID
  createTime?: Date
}

// 获取提成记录分页
export const getCommissionRecordPage = (params: any) => {
  return request.get({ url: '/hotel/commission-record/page', params })
}

// 获取提成记录详情
export const getCommissionRecord = (id: string | number) => {
  return request.get({ url: '/hotel/commission-record/get?id=' + id })
}

// 创建提成记录
export const createCommissionRecord = (data: CommissionRecordVO) => {
  return request.post({ url: '/hotel/commission-record/create', data })
}

// 更新提成记录
export const updateCommissionRecord = (data: CommissionRecordVO) => {
  return request.put({ url: '/hotel/commission-record/update', data })
}

// 删除提成记录
export const deleteCommissionRecord = (id: string | number) => {
  return request.delete({ url: '/hotel/commission-record/delete?id=' + id })
}

// 批量删除提成记录
export const deleteCommissionRecordList = (ids: (string | number)[]) => {
  return request.delete({ url: '/hotel/commission-record/delete-list?ids=' + ids.join(',') })
}
